var _rect, _rect2, _rect3, _rect4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMarkerAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 5.5,
    width: 23.0008,
    height: 23,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 5.5,
    width: 23.0008,
    height: 23,
    rx: 7.5,
    stroke: "#1C83C6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 5.5,
    width: 23.0008,
    height: 23,
    rx: 7.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 5.5,
    width: 23.0008,
    height: 23,
    rx: 7.5,
    stroke: "#1C83C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7578 11.6434C20.626 11.6789 20.4414 11.8594 20.4033 11.9879C20.3828 12.0535 20.3711 12.5812 20.3711 13.4645V14.8371L18.8389 14.8453L17.3066 14.8535L17.1865 14.9273C17.1221 14.9684 17.0371 15.0477 16.999 15.1051L16.9287 15.209L16.9199 16.6363L16.9111 18.0637L15.3789 18.0719L13.8496 18.0801L13.7295 18.1539C13.665 18.1949 13.5801 18.2742 13.542 18.3316L13.4717 18.4355L13.4629 19.8629L13.4541 21.2902L11.9219 21.2984L10.3926 21.3066L10.2725 21.3805C10.0908 21.4926 10.0146 21.6266 10.0146 21.8398C10.0146 22.0531 10.0908 22.1871 10.2725 22.2992L10.3926 22.373H12.3115H14.2334L14.3564 22.2937C14.4238 22.2527 14.5117 22.1707 14.5469 22.116L14.6143 22.0176L14.623 20.5902L14.6318 19.1629L16.1611 19.1547L17.6904 19.1465L17.8135 19.0672C17.8809 19.0262 17.9688 18.9441 18.0039 18.8895L18.0713 18.791L18.0801 17.3637L18.0889 15.9363L19.6182 15.9281L21.1475 15.9199L21.2588 15.8461C21.3232 15.8078 21.4082 15.7285 21.4492 15.6684L21.5283 15.5645L21.5371 14.1371L21.5459 12.7098L23.0781 12.7016L24.6074 12.6934L24.7275 12.6195C24.9092 12.5074 24.9854 12.3734 24.9854 12.1602C24.9854 11.9469 24.9092 11.8129 24.7275 11.7008L24.6074 11.627L22.7324 11.6215C21.5986 11.6187 20.8164 11.627 20.7578 11.6434Z",
    fill: "#1C83C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7841 17.7683C20.6435 17.8203 20.538 17.916 20.4706 18.05C20.3798 18.2332 20.3828 18.3562 20.4824 18.534C20.5468 18.6516 20.5937 18.6953 20.7197 18.7555C20.872 18.8293 20.8896 18.832 21.332 18.832H21.7919L20.3359 20.191C19.0175 21.4242 18.8798 21.5637 18.8476 21.6758C18.7773 21.9246 18.8798 22.1789 19.1025 22.3074C19.2607 22.4004 19.5507 22.4004 19.6972 22.3074C19.7529 22.2719 20.4355 21.6512 21.2148 20.9266L22.6269 19.6113V20.0379C22.6269 20.4535 22.6298 20.4699 22.7089 20.6121C22.7734 20.7297 22.8203 20.7734 22.9462 20.8336C23.0341 20.8773 23.1484 20.9101 23.2099 20.9101C23.374 20.9101 23.6025 20.7926 23.6992 20.6558L23.7841 20.541V19.3187V18.0992L23.6962 17.9816C23.6494 17.9187 23.5497 17.8367 23.4794 17.8012L23.3505 17.7383L22.1025 17.741C21.3935 17.741 20.8251 17.7519 20.7841 17.7683Z",
    fill: "#1C83C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarkerAccess);
export default __webpack_public_path__ + "static/media/Ic_Marker_Access.0499b37d5dce74ff1fb389c3c4023db3.svg";
export { ForwardRef as ReactComponent };